import React from 'react';

const NotFoundPage = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1 style={{ color: '#FF0000' }}>404</h1>
      <p>ページが見つかりません。</p>
      <a href="/" style={{ textDecoration: 'none', color: '#007BFF' }}>ホームに戻る</a>
    </div>
  );
};

export default NotFoundPage;